import { Routes } from "@angular/router";
import { anonymousGuard } from "./guards/anonymous.guard";
import { authGuard } from "./guards/auth.guard";

export const routes: Routes = [
  { path: "", redirectTo: "auth/login", pathMatch: "full" },
  {
    path: "",
    loadChildren: () =>
      import("./components/authentication/authentication.routes").then(
        (authenticationRoutes) => authenticationRoutes.routes
      ),
    canActivate: [anonymousGuard],
  },

  {
    path: "",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./components/dashboard/dashboard.routes").then(
        (dashbord) => dashbord.routes
      ),
  },

  {
    path: "",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./components/licences/licences.routes").then(
        (licence) => licence.routes
      ),
  },

  {
    path: "",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./components/arms/arms.routes").then((arms) => arms.routes),
  },
  {
    path: "",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./components/ammunition/ammunition.routes").then(
        (ammunition) => ammunition.routes
      ),
  },
  {
    path: "drafts",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./components/drafts/drafts.routes").then(
        (drafts) => drafts.routes
      ),
  },

  {
    path: "terms-conditions",
    loadComponent: () =>
      import(
        "./components/pages/terms-condition/terms-condition.component"
      ).then((m) => m.TermsConditionComponent),
  },
  {
    path: "privacy-policy",
    loadComponent: () =>
      import("./components/pages/privacy-policy/privacy-policy.component").then(
        (m) => m.PrivacyPolicyComponent
      ),
  },
];
